
import Vue from 'vue';

Vue.mixin({
    methods: {
  
      async api_upload(data,root,id) {
      
        const res = await this.$http.post(this.$store.state.api_url+'?id='+id+'&root='+root,data,{header:{ 'Content-Type' : 'multipart/form-data'} })

        return await res;
      },
     

      async api_get(data) {
      
        const res = await this.$http.post(this.$store.state.api_url,{state:JSON.stringify(data)})
        return await res;
      },
     
    }
  })